import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    useEffect(() => {}, []);

    useEffect(() => {
        scrollTop();
    }, [pathname]);

    const scrollTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <footer className="footer-wrapper">

        </footer>
    );
};

export default Footer;
